/**
 * Copyright © 2026 Adnuntius AS.
 */
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {NgSelectModule} from '@ng-select/ng-select';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';

import {APP_SHARED} from '../../app-shared';
import {AdnSelectComponent} from '../adn-select/adn-select.component';

export const FORM_CONTROL_IMPORTS = [
  ...APP_SHARED,
  FormsModule,
  TranslateModule,
  NgSelectModule,
  AdnSelectComponent,
  BsDatepickerModule,
  TimepickerModule
];
